import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { Container } from '@pwskills/rachnaui';
import { useContext } from 'react';

const PremiumInstituteNavBar = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { partnerInstituteDetails } = courseDetails || {};
  return (
    <Container className="!py-3 large:!py-4 !px-8 large:!px-20 inline-flex">
      <img
        src={partnerInstituteDetails && partnerInstituteDetails[0]?.logoPremiumInstituteHeader}
        alt="collegeLogo"
        className="h-[36px] medium:h-[40px] large:h-[52px] w-auto flex-shrink-0"
      />
    </Container>
  );
};

export default PremiumInstituteNavBar;
